import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { User } from '../../user/models/user.model';
import { AdminState } from './admin.reducers';
import { adminsQuery } from './admin.selectors';
import {
  fetchAdminsRequest,
  createAdminsRequest,
  deleteAdminsRequest,
} from './admin.actions';

@Injectable()
export class AdminFacade {
  constructor(private store: Store<AdminState>) {}

  public admins$ = this.store.select(adminsQuery.getAdmins);
  public isFetching$ = this.store.select(adminsQuery.getIsFetching);

  fetchAdmins() {
    this.store.dispatch(fetchAdminsRequest());
  }

  createAdmin(payload: User) {
    this.store.dispatch(createAdminsRequest({ payload }));
  }

  deleteAdmins(payload: { ids: number[] }) {
    this.store.dispatch(deleteAdminsRequest({ payload }));
  }
}
